import React from 'react';
import theme from './OptionGroupWizard.module.scss';
import { UnitSelector } from '../../UnitSelector';

export interface OptionGroupWizardLinkUnitsStepProps {
    projectId: number;
    value: number[];
    /** Units with a live order - locked so they cannot be unlinked. */
    lockedUnitIds?: number[];
    onChange(newValue: number[]): void;
}

export const OptionGroupWizardLinkUnitsStep: React.FC<OptionGroupWizardLinkUnitsStepProps> = ({
    projectId,
    value,
    lockedUnitIds,
    onChange,
}) => {
    const handleChange = (unitIds: number[]) => {
        onChange(unitIds);
    };

    return (
        <div className={theme.roomList}>
            <UnitSelector
                projectId={projectId}
                selectedResidentialUnitIds={value}
                lockedResidentialUnitIds={lockedUnitIds}
                onChange={handleChange}
            />
        </div>
    );
};
